@use "../common.scss" as *;
@import "../../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: block;
  block-size: 100%;
  overflow: auto;
}

.main {
  overflow: auto;
  display: block;
}

ch-accordion-render {
  inline-size: 100%;
  block-size: 100%;
}

.native-apps-accordion {
  inline-size: 100%;
  block-size: 100%;
}

/* WA: Platform Section */
.platform-section {
  display: flex;
  align-items: center;
  gap: var(--spacing-gap-l);
}

.app__apple-store {
  height: 32px; // This should equal the button height in Mercury
  cursor: pointer;
  transition: opacity var(--timing-fast) ease;

  &:hover {
    opacity: 0.8;
  }
}

.platform-grid {
  --card-min-inline-size: 360px;
  @extend %appCardsContainer;
}

.object-card {
  @extend %appCard;
}

.card-content {
  display: flex;
  gap: var(--spacing-gap-xl);
  flex: 1;
  width: 100%;

  &:focus {
    outline: none;
  }
}

.info-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}

.app-info {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-xs);
  flex: 1;
}

.name {
  color: var(--color-text-neutral-default);
}

.description {
  color: var(--color-text-neutral-disabled);
  margin: 0;
  line-height: var(--line-height-relaxed);
}

/* Copy button styles handled by Mercury components/button bundle */

/* QR Dialog Styles */
.dialog {
  --ch-dialog-block-size: 400px;
  --ch-dialog-inline-size: 350px;
  --ch-dialog-min-block-size: 400px;
  --ch-dialog-min-inline-size: 350px;
}
.qr-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid var(--color-border-neutral-default);
}

/* No Data States */
.no-data,
.no-results {
  color: var(--color-text-neutral-disabled);
  font-style: italic;
  text-align: center;
  padding: 16px;

  p {
    font-size: var(--font-size-body-m);
    font-weight: var(--font-style-semi-bold);
    line-height: var(--line-height-spacious);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .platform-grid {
    justify-content: center;
  }

  .card-content {
    flex-direction: column;
    gap: var(--spacing-gap-l);
  }

  .card-actions {
    flex-direction: column;
    gap: var(--spacing-gap-l);
    align-items: stretch;
  }
}

@media (max-width: 480px) {
  .main {
    padding: 12px;
  }

  .object-card {
    padding: 12px;
  }

  .platform-grid {
    gap: var(--spacing-gap-l);
    padding: 12px;
  }
}

.android:after {
  content: "";
  display: block;
}
